import { render, staticRenderFns } from "./tabSchedule.vue?vue&type=template&id=5b0282dc"
import script from "./tabSchedule.vue?vue&type=script&lang=js"
export * from "./tabSchedule.vue?vue&type=script&lang=js"
import style0 from "./tabSchedule.vue?vue&type=style&index=0&id=5b0282dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports